// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
    apiKey: "AIzaSyDN7EwqZzfwOi3CUaI2AcUahVvxzBmIe9k",
    authDomain: "destion-innovations-9f907.firebaseapp.com",
    databaseURL: "https://destion-innovations-9f907-default-rtdb.firebaseio.com",
    projectId: "destion-innovations-9f907",
    storageBucket: "destion-innovations-9f907.appspot.com",
    messagingSenderId: "154567385984",
    appId: "1:154567385984:web:94b4d33fc333f39a849765",
    measurementId: "G-5627F1P2LR"
  };
  
  // Initialize Firebase
  // const app = initializeApp(firebaseConfig);
  // const analytics = getAnalytics(app);
  
  export default firebaseConfig;

